import {createContext} from 'react';
import {defaultContext} from './reducer/model';

export const AutomationContext = createContext(defaultContext);
